class TestimonialSliderCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.mediaEl = this.querySelector('[data-role="media"]');
    this.contentEl = this.querySelector('[data-role="content"]');
    this.fractionCurrent = this.querySelector(".ts-fraction-current");
    this.fractionTotal = this.querySelector(".ts-fraction-total");
    this.progressFill = this.querySelector(".ts-progress__fill");
    this.prevBtn = this.querySelector(".ts-arrow--prev");
    this.nextBtn = this.querySelector(".ts-arrow--next");

    this.addEventListener("click", this.onBuyClick.bind(this));

    if (!this.mediaEl || !this.contentEl || typeof Swiper === "undefined") {
      return;
    }

    const total = this.mediaEl.querySelectorAll(".swiper-slide").length;
    if (this.fractionTotal) {
      this.fractionTotal.textContent = String(total).padStart(2, "0");
    }

    const autoplayEnabled = this.dataset.autoplay === "true";
    const autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
    const loop = this.dataset.loop !== "false" && total > 1;

    this.contentSwiper = new Swiper(this.contentEl, {
      effect: "slide",
      speed: 600,
      loop,
      allowTouchMove: false,
    });

    this.mediaSwiper = new Swiper(this.mediaEl, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: 600,
      loop,
      autoplay: autoplayEnabled
        ? { delay: autoplaySpeed, disableOnInteraction: false }
        : false,
      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn,
      },
      on: {
        slideChange: () => this.updateFraction(),
        autoplayTimeLeft: (swiper, timeLeft, progress) =>
          this.updateProgress(progress),
      },
    });

    this.mediaSwiper.controller.control = this.contentSwiper;
    this.contentSwiper.controller.control = this.mediaSwiper;

    this.updateFraction();

    if (autoplayEnabled && typeof Motion !== "undefined" && Motion.inView) {
      this.mediaSwiper.autoplay.stop();
      Motion.inView(this, () => this.mediaSwiper.autoplay.start(), {
        margin: "0px 0px -50px 0px",
      });
    }
  }

  updateFraction() {
    if (!this.mediaSwiper || !this.fractionCurrent) return;
    const index = this.mediaSwiper.realIndex + 1;
    this.fractionCurrent.textContent = String(index).padStart(2, "0");
  }

  updateProgress(progress) {
    if (!this.progressFill) return;
    const value = Math.min(Math.max(1 - progress, 0), 1) * 100;
    this.progressFill.style.width = `${value}%`;
  }

  onBuyClick(event) {
    const button = event.target.closest(".ts-card__buy");
    if (!button || button.disabled) return;
    event.preventDefault();
    this.addToCart(button);
  }

  addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || typeof routes === "undefined" || !routes.cart_add_url) {
      return;
    }

    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    button.classList.add("loading");
    button.disabled = true;

    const config =
      typeof fetchConfig === "function" ? fetchConfig("json") : {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
      };

    config.body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors || parsedState.status) {
          return;
        }

        if (cart) {
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            if (!elementToReplace || !parsedState.sections?.[section.id]) return;
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            const minicartForm = html.querySelector("#minicart-form");
            if (minicartForm) {
              elementToReplace.innerHTML = minicartForm.innerHTML;
            }
          });

          if (typeof cart.cartAction === "function") cart.cartAction();
          if (typeof showMinicartAddSuccessMessage === "function") {
            showMinicartAddSuccessMessage(cart);
          } else if (typeof window.showMinicartMessage === "function") {
            window.showMinicartMessage({
              cart,
              message: window?.cartStrings?.item_added,
              type: "success",
              duration: 4200,
            });
          }
          if (typeof cart.open === "function") cart.open();
        }

        fetch("/cart.js")
          .then((res) => res.json())
          .then((jsonCart) => {
            document.querySelectorAll(".cart-count").forEach((el) => {
              if (el.classList.contains("cart-count-drawer")) {
                el.innerHTML = `(${jsonCart.item_count})`;
              } else {
                el.innerHTML = jsonCart.item_count > 100 ? "~" : jsonCart.item_count;
              }
            });
          })
          .catch(() => {});
      })
      .catch(() => {})
      .finally(() => {
        button.classList.remove("loading");
        button.disabled = false;
      });
  }
}

customElements.define("testimonial-slider-carousel", TestimonialSliderCarousel);
